/**
 * Expects primaryBusinessType object from a company query
 *
 * Returns the heirarchical type that is used to display different
 * Company/Exhibitor/Retailer profile sections or functionality
 *
 * @param object primaryBusinessType
 * @returns string that describes the display type
 */
export const getCompanyDisplayType = primaryBusinessType => {
    if (!primaryBusinessType) {
        return 'Other';
    }

    switch (primaryBusinessType.code) {
        case 'OWN':
        case 'SCM':
            return 'OwnerDeveloper';

        case 'RES':
            return 'Broker';

        case 'RET':
            return 'RetailerTenant';

        case 'PRF':
        case 'ADV':
        case 'ARC':
        case 'BLD':
        case 'COM':
        case 'CON':
        case 'RSC':
        case 'ENT':
        case 'INS':
        case 'LEG':
        case 'MNT':
        case 'PRK':
        case 'PRS':
        case 'PBL':
        case 'SEC':
        case 'TNS':
        case 'UTL':
            return 'ServiceProduct';

        default:
            return 'Other';
    }
};
